module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-ladeinfrastruktur-aea5ec944a1e0741d82fdcef250fcf00.svg";